import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';
import EditDebtModal from '../../../components/Modal/EditDebtModal';
import CustomerUnpaidModal from '../../../components/Modal/CustomerUnpaidModal';

// Utils
import {
    getDataWithComp,
    getAlert,
    formatCurrency
} from '../../../../utils/SamuiUtils';

import {
    formatDateAndTime,
} from '../../../../utils/DateUtils';

import { ExportPaymentStockReport } from '../../../../utils/ExportUtils';
import ArModal from '../../../components/Modal/ArModal';

function Form({ name }) {
    const [formArList, setFormArList] = useState([]);
    const [formItemHistory, setFormItemHistory] = useState([]);
    const [arId, setArId] = useState(null);
    const [arCode, setArCode] = useState(null);
    const [arName, setArName] = useState(null);
    const [filterType, setFilterType] = useState('unpaid');
    const [filterOption, setFilterOption] = useState('pending');
    const [filteredArList, setFilteredArList] = useState([]);

    // Modal ปรับปรุงยอดค้างชำระ
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isUnpaidModalOpen, setUnpaidModalOpen] = useState(false);
    const [unpaidArId, setUnpaidArId] = useState(null);
    const [unpaidArName, setUnpaidArName] = useState('');

    useEffect(() => {
        initialize();
    }, []);

    useEffect(() => {
        // เคลียร์ก่อน
        setFilteredArList([]);

        const timeout = setTimeout(() => {
            const newList = formArList.filter((item) => {
                const matchesSearch =
                    item.AR_Code.includes(arCode || '') ||
                    item.AR_Name.includes(arName || '');

                let matchesFilter = true;

                if (filterType === "unpaid") {
                    matchesFilter = item.Item_Onhand !== null;
                } else if (filterType === "credit") {
                    matchesFilter = item.Item_Onhand_Credit !== null;
                }

                if (filterOption === "pending") {
                    matchesFilter = matchesFilter && (filterType === "credit" ? item.Item_Onhand_Credit < 0 : item.Item_Onhand < 0);
                } else if (filterOption === "not_pending") {
                    matchesFilter = matchesFilter && (filterType === "credit" ? item.Item_Onhand_Credit >= 0 : item.Item_Onhand >= 0);
                }

                return matchesSearch && matchesFilter;
            });

            setFilteredArList(newList);
        }, 50);

        return () => clearTimeout(timeout);
    }, [formArList, arCode, arName, filterType, filterOption]);

    const initialize = async () => {
        try {
            // เคลียค่าทุกครั้ง เมื่อเปิดหน้าจอ
            setFormArList([]);
            setFormItemHistory([]);

            // ค้นหาข้อมูลตั้งต้นจาก API_0002_Set_Item
            const arList = await getDataWithComp('API_1401_WH_ARPAYMENT_ONHAND', `ORDER BY AR_Code ASC`);
            if (arList && arList.length > 0) {
                setFormArList(arList);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // API_1501_WH_ARPAYMENT_STC (ประวัติการชําระเงิน)
    const onRowSelectHistory = async (arId) => {
        try {
            setArId(arId);
            setFormItemHistory([]);
            const itemHistory = await getDataWithComp('API_1501_WH_ARPAYMENT_STC', `AND Item_Id = ${arId} ${filterType === 'unpaid' ? `AND (Paid_Type <> 4 OR Paid_Type IS NULL)` : `AND Paid_Type = 4`} ORDER BY STC_SEQ DESC`);
            if (itemHistory && itemHistory.length > 0) {
                setFormItemHistory(itemHistory);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
            setFormItemHistory([]);
        }
    };

    const openModal = (item) => {
        setSelectedItem(item);
        setModalOpen(true);
    };

    const closeModal = () => {
        setSelectedItem(null);
        setModalOpen(false);
    };

    const openUnpaidModal = (item) => {
        setUnpaidArId(item?.AR_Id || null);
        setUnpaidArName(item?.AR_Name || '');
        setUnpaidModalOpen(true);
    };

    const closeUnpaidModal = () => {
        setUnpaidModalOpen(false);
        setUnpaidArId(null);
        setUnpaidArName('');
    };

    // SET AR
    const [showArModal, setShowArModal] = useState(false);
    const handleArShow = () => setShowArModal(true);
    const handleArClose = () => setShowArModal(false);
    const onRowSelectAr = (arSelected) => {
        try {
            setArId(arSelected.AR_Id);
            setArCode(arSelected.AR_Code);
            setArName(arSelected.AR_Name);
            handleArClose();
        } catch (error) {
            getAlert("FAILED", error);
        }
    };

    return (
        <>
            <Breadcrumbs page={'ตรวจสอบค้างจ่าย'} items={[
                { name: 'งานบัญชี', url: '/account' },
                { name: name, url: '/payment-stock' },
            ]} />
            <div className="row mt-1 hidden-scrollbar" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <div className="col-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="container-fluid">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <div className='row mt-3'>
                                            <div className='col-12'>
                                                {/* ประเภท */}
                                                <div className="d-flex flex-row align-items-center text-start">
                                                    <div className='col-3'><span className="me-3">ประเภท :</span></div>
                                                    <div className="form-check form-check-inline form-check-lg me-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="filterType"
                                                            value="unpaid"
                                                            checked={filterType === "unpaid"}
                                                            onChange={() => setFilterType("unpaid")}
                                                        />
                                                        ค้างจ่าย
                                                    </div>
                                                    <div className="form-check form-check-inline form-check-lg me-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="filterType"
                                                            value="credit"
                                                            checked={filterType === "credit"}
                                                            onChange={() => setFilterType("credit")}
                                                        />
                                                        เครดิต
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                {/* การแสดงผล */}
                                                <div className="d-flex flex-row align-items-center text-start">
                                                    <div className='col-3'><span className="me-3">การแสดงผล :</span></div>
                                                    <div className="form-check form-check-inline form-check-lg me-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="filterOption"
                                                            value="pending"
                                                            checked={filterOption === "pending"}
                                                            onChange={() => setFilterOption("pending")}
                                                        />
                                                        ค้างจ่าย
                                                    </div>
                                                    <div className="form-check form-check-inline form-check-lg me-2">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="filterOption"
                                                            value="not_pending"
                                                            checked={filterOption === "not_pending"}
                                                            onChange={() => setFilterOption("not_pending")}
                                                        />
                                                        ไม่ค้างจ่าย
                                                    </div>
                                                    <div className="form-check form-check-inline form-check-lg">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="filterOption"
                                                            value="all"
                                                            checked={filterOption === "all"}
                                                            onChange={() => setFilterOption("all")}
                                                        />
                                                        แสดงทั้งหมด
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card-body">
                                <div className="col-8 d-flex align-items-center ">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control input-spacing"
                                            name="apCode"
                                            placeholder='ค้นหาลูกค้า'
                                            value={
                                                (arCode || "") +
                                                " " +
                                                (arName || "")
                                            }
                                            disabled={true}
                                        />
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={handleArShow}
                                        >
                                            <i className="fas fa-search"></i>
                                        </button>
                                        <button
                                            className="btn btn-danger ms-2"
                                            onClick={async () => {
                                                setArCode("");
                                                setArName("");
                                            }}
                                        >
                                            รีเซ็ต
                                        </button>
                                    </div>
                                </div>
                                <ArModal
                                    showArModal={showArModal}
                                    handleArClose={handleArClose}
                                    arDataList={formArList}
                                    onRowSelectAr={onRowSelectAr}
                                />

                                <div className="table-responsive mt-3" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                    <table id="basic-datatables" className="table table-striped table-hover">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th className="text-center" style={{ width: '1%' }}>#</th>
                                                <th className="text-center" style={{ width: '17%' }}>รหัสลูกค้า</th>
                                                <th className="text-center" style={{ width: '50%' }}>ชื่อลูกค้า</th>
                                                <th className="text-center" style={{ width: '20%' }}>{filterType === "unpaid" ? "ค้างจ่าย" : "เครดิต"}</th>
                                                <th className="text-center" style={{ width: '10%' }}>ใบขายค้างชำระ</th>
                                                <th className="text-center" style={{ width: '2%' }}>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredArList.length > 0 ? (
                                                filteredArList.map((item, index) => (
                                                    <tr
                                                        key={item.AR_Id}
                                                        onClick={() => {
                                                            onRowSelectHistory(item.AR_Id);
                                                        }}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: arId === item.AR_Id ? 'rgb(105, 188, 216)' : 'transparent',
                                                            transition: 'background-color 0.3s ease'
                                                        }}
                                                    >
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{item.AR_Code}</td>
                                                        <td className="text-left">{item.AR_Name}</td>
                                                        {filterType === "unpaid" ? (
                                                            <td
                                                                className="text-end"
                                                                style={{
                                                                    color: item.Item_Onhand < 0 ? 'red' : item.Item_Onhand > 0 ? 'green' : 'inherit',
                                                                    fontWeight: 'bold'
                                                                }}
                                                            >
                                                                {formatCurrency(item.Item_Onhand)}
                                                            </td>
                                                        ) : (
                                                            <td
                                                                className="text-end"
                                                                style={{
                                                                    color: item.Item_Onhand_Credit < 0 ? 'red' : item.Item_Onhand_Credit > 0 ? 'green' : 'inherit',
                                                                    fontWeight: 'bold'
                                                                }}
                                                            >
                                                                {formatCurrency(item.Item_Onhand_Credit)}
                                                            </td>
                                                        )}
                                                        <td className="text-center">
                                                            <i
                                                                className="fa fa-eye"
                                                                style={{ color: '#EF6C00', cursor: 'pointer' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openUnpaidModal(item);
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <i
                                                                className="fa fa-pen"
                                                                style={{ color: '#EF6C00', cursor: 'pointer' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    openModal(item);
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={6}>
                                                        <center>
                                                            <h5>ไม่พบข้อมูล</h5>
                                                        </center>
                                                    </td>
                                                </tr>
                                            )}
                                            <EditDebtModal
                                                isOpen={isModalOpen}
                                                onClose={closeModal}
                                                item={selectedItem}
                                                initialize={initialize}
                                                paidType={filterType === 'unpaid' ? 5 : 4}
                                            />
                                            <CustomerUnpaidModal
                                                isOpen={isUnpaidModalOpen}
                                                onClose={closeUnpaidModal}
                                                arId={unpaidArId}
                                                arName={unpaidArName}
                                            />
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex justify-content-end mt-3">
                                    <button
                                        className="btn d-flex align-items-center text-white"
                                        style={{ backgroundColor: 'rgb(239, 108, 0)', fontSize: '16px' }}
                                        onClick={() => ExportPaymentStockReport(filteredArList)}
                                    >
                                        <i className="fa fa-print me-2" aria-hidden="true"></i>
                                        พิมพ์รายการลูกค้าค้างจ่าย
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className={`tab-pane fade show active`} role="tabpanel">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="container-fluid">
                                        <div className="d-flex flex-row">
                                            <h5 className="card-title mt-3 me-4 text-center">ประวัติยอดเงินเคลื่อนไหว</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table id="basic-datatables" className="table table-striped table-hover">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: '1%' }}>#</th>
                                                    <th className="text-center" style={{ width: '14%' }}>ประเภท</th>
                                                    <th className="text-center" style={{ width: '15%' }}>จำนวน</th>
                                                    <th className="text-center" style={{ width: '15%' }}>ยอดเงินคงเหลือ</th>
                                                    <th className="text-center" style={{ width: '15%' }}>วันที่ทำรายการ</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เอกสารอ้างอิง</th>
                                                    <th className="text-center" style={{ width: '20%' }}>หมายเหตุ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formItemHistory.length > 0 ? (
                                                    formItemHistory.map((item, index) => (
                                                        <tr key={item.STC_Id}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{item.Doc_Type === 'AO' ? 'ค้างจ่าย' : 'จ่ายแล้ว'}</td>
                                                            <td className="text-center">
                                                                {
                                                                    item.Doc_Type === 'TO'
                                                                        || item.Doc_Type === 'AO'
                                                                        || item.Doc_Type === 'OUT' ? '-' : ''
                                                                }
                                                                {formatCurrency(Math.abs(item.STC_QTY))}
                                                            </td>
                                                            <td className="text-center">{formatCurrency(item.STC_Balance)}</td>
                                                            <td className="text-center">{formatDateAndTime(item.STC_Date)}</td>
                                                            <td className="text-center">{item.Doc_No}</td>
                                                            <td className="text-center">
                                                                {item.Doc_NoRef && item.Doc_NoRef.split('ยกเลิก').map((part, index, array) => (
                                                                    <React.Fragment key={index}>
                                                                        {part}
                                                                        {index < array.length - 1 && (
                                                                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                <strong>ยกเลิก</strong>
                                                                            </span>
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}
                                                            </td>
                                                            <td className="text-center">{item.STC_Remark || '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <center>
                                                                <h5>ไม่พบข้อมูล</h5>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Form;
